/**
 * --------------------------------------------------------------------------
 * Basic Modules: ClearFields.js
 * --------------------------------------------------------------------------
 */

//import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'clearFields';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {};

const Event = {
    RESIZE              : `resize${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
    KEY_UP              : `keyup${EVENT_KEY}`,
    CHANGE              : `change${EVENT_KEY}`,
};

const ClassName = {
    CLEAR_FIELD: 'search-clear-field',
    CLEAR_FIELD_WRAPPER: 'search-clear-field-wrapper',
    AUTOSIZE: "autosize",
};

const Selector = {
    TOGGLE              : '.js-clear-fields',
};

//const DataAttr = {};

class ClearFields {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.resizeTimeout = null;
        this.scrollInitialized = false;

        this._element = element;
        this._config  = this._getConfig(config);

        this._setup();

        this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _setup() {
        let _this = this,
            $input = $(this._element),
            wrapperClass = ClassName.CLEAR_FIELD_WRAPPER;

        $input.hasClass(ClassName.AUTOSIZE) && (wrapperClass += " " + ClassName.AUTOSIZE);

        let $wrapper = $("<div/>", {
            "class": wrapperClass,
            html: ""
        });

        let $clearBtn = $("<button/>", {
            "class": ClassName.CLEAR_FIELD,
            type: "button",
            html: "invoer wissen"
        });

        $input.wrap($wrapper);
        $clearBtn.insertAfter($input);

        $clearBtn.on(Event.CLICK, () => {
            this._clear($input, $clearBtn)
        });

        this._toggleClearBtn($input, $clearBtn);
        $input.on(Event.KEY_UP, () => {
            this._toggleClearBtn($input, $clearBtn)
        });
        $input.on(Event.CHANGE, () => {
            this._toggleClearBtn($input, $clearBtn)
        })
    }

    _clear($input, $btn) {
        $input.val("").focus();
        $btn.removeClass("active");
    }

    _toggleClearBtn($input, $btn) {
        $input.val() !== "" ? $btn.addClass("active") : $btn.removeClass("active")
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
    }

    /**
     * Handle the resizing of the window
     * @private
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        // do stuff when window is resized.

        this._setup();

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        ClearFields._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new ClearFields(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = ClearFields._jQueryInterface;
$.fn[NAME].Constructor = ClearFields;


export default ClearFields;
